import { Component, computed, inject, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CountryService } from '@core/services/country-service/country-service';
import { Location } from '@moon-v2/moon-share';
import { Loader } from '@shared/components/loader';

@Component({
  selector: 'app-country-selector-modal',
  imports: [Loader, FormsModule, TranslateModule],
  templateUrl: './country-selector-modal.html',
  styleUrl: './country-selector-modal.scss',
})
export class CountrySelectorModal {
  private readonly countryService = inject(CountryService);

  // Pays disponibles (signal)
  countries = this.countryService.countries;

  // Terme de recherche et liste filtrée
  searchTerm = signal('');
  filteredCountries = computed(() => {
    const term = this.searchTerm().trim().toLowerCase();
    const countries = this.countries() ?? [];
    if (!term) {
      return countries;
    }
    return countries.filter((c) => c.name.toLowerCase().includes(term));
  });

  // Événement émis lors de la fermeture du modal
  closeModal = output<void>();

  // Pays sélectionné localement (avant confirmation)
  selectedCountry: Location | null = null;

  selectCountry(country: Location): void {
    this.selectedCountry = country;
  }

  confirmSelection(): void {
    if (this.selectedCountry) {
      // Enregistre le pays dans le service
      this.countryService.setCountry(this.selectedCountry);
      // Ferme le modal
      this.closeModal.emit();
    }
  }

  isSelected(country: Location): boolean {
    return this.selectedCountry?.uuid === country.uuid;
  }

  getCountryFlag(countryName: string): string {
    const flags: Record<string, string> = {
      TOGO: 'assets/img/icons/flags/togo-flag.svg',
      SENEGAL: 'assets/img/icons/flags/senegal-flag.png',
      MALAWI: 'assets/img/icons/flags/malawi-flag.png',
      MADAGASCAR: 'assets/img/icons/flags/madagascar-flag.png',
      SIERRA_LEONE: 'assets/img/icons/flags/sierra-leone-flag.png',
    };

    // Normaliser le nom du pays en majuscules et remplacer les espaces par des underscores
    const normalizedName = countryName.toUpperCase().replace(/\s+/g, '_');

    // Retourner le drapeau correspondant ou un drapeau par défaut
    return flags[normalizedName] || 'assets/img/icons/flags/earth.png';
  }
}
